"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translation_en = void 0;
exports.translation_en = {
    activationQR: {
        title: 'Gate configuration code',
        gateName: 'Gate name',
        controller: 'Controller'
    },
    ticket: {
        organizer: 'Organizer',
        ticketLabel: 'Event entry ticket',
        moreInfo: 'more information',
        demo: 'DEMO VERSION'
    }
};
